<template>
  <div class="flex flex-col space-y-6 p-6 min-h-screen">
    <div v-if="kpiStats" class="space-y-6">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-6">
        <div
          class="bg-white rounded-lg shadow-sm p-4 border border-[#ec4400] flex items-stretch"
        >
          <div
            class="flex-shrink-0 flex items-center justify-center w-16 rounded-l-lg"
          >
            <img
              src="@/assets/man.png"
              alt="Icône pour le total des visitors"
              class="h-20 w-auto object-contain"
            />
          </div>
          <div class="flex-1 flex flex-col justify-center items-center p-2">
            <h5
              class="text-gray-600 text-xs font-medium text-center uppercase mb-1"
            >
              Visites terminées
            </h5>
            <p class="text-3xl font-bold" style="color: #ec4400">
              {{ kpiStats.totalUniqueVisitors }}
            </p>
          </div>
        </div>

        <div
          class="bg-white rounded-lg shadow-sm p-4 border border-[#ec4400] flex items-stretch"
        >
          <div
            class="flex-shrink-0 flex items-center justify-center w-16 rounded-l-lg"
          >
            <img
              src="@/assets/visiteurin_N.png"
              alt="Icône pour les visitors présents"
              class="h-20 w-auto object-contain"
            />
          </div>
          <div class="flex-1 flex flex-col justify-center items-center p-2">
            <h5
              class="text-gray-600 text-xs font-medium text-center uppercase mb-1"
            >
              Visites en cours
            </h5>
            <p class="text-3xl font-bold" style="color: #ec4400">
              {{ kpiStats.ongoingVisitors }}
            </p>
          </div>
        </div>

        <div
          class="bg-white rounded-lg shadow-sm p-4 border border-[#ec4400] flex items-stretch"
        >
          <div
            class="flex-shrink-0 flex items-center justify-center w-16 rounded-l-lg"
          >
            <img
              src="@/assets/heurepointe_N.png"
              alt="Icône pour l'heure de pointe"
              class="h-20 w-auto object-contain"
            />
          </div>
          <div class="flex-1 flex flex-col justify-center items-center p-2">
            <h5
              class="text-gray-600 text-xs font-medium text-center uppercase mb-1"
            >
              Heure d'affluence
            </h5>
            <p class="text-3xl font-bold" style="color: #ec4400">
              {{ kpiStats.peakHour || "N/A" }}
            </p>
          </div>
        </div>

        <div
          class="bg-white rounded-lg shadow-sm p-4 border border-[#ec4400] flex items-stretch"
        >
          <div
            class="flex-shrink-0 flex items-center justify-center w-16 rounded-l-lg"
          >
            <img
              src="@/assets/duree_N.png"
              alt="Icône pour la durée moyenne de visite"
              class="h-20 w-auto object-contain"
            />
          </div>
          <div class="flex-1 flex flex-col justify-center items-center p-2">
            <h5
              class="text-gray-600 text-xs font-medium text-center uppercase mb-1"
            >
              Durée moyenne
            </h5>
            <p class="text-3xl font-bold" style="color: #ec4400">
              {{ kpiStats.averageDuration }}
            </p>
          </div>
        </div>

      </div>
    </div>

    <div v-else class="text-center text-gray-600">
      Chargement des statistiques...
    </div>

    <div v-if="errorMessage" class="text-center text-red-600">
      {{ errorMessage }}
    </div>

    <div v-else-if="paginatedvisitors.length === 0 && kpiStats" class="text-center text-gray-600">
      Aucun visiteur trouvé pour les filtres actuels.
    </div>

    <div class="flex flex-col sm:flex-row justify-between items-center space-y-3 sm:space-y-0 sm:space-x-3">
      <div class="flex items-center space-x-3 w-full flex-wrap sm:flex-nowrap">
        <input
          type="text"
          v-model="searchQuery"
          placeholder="Rechercher par nom, prénoms, entreprise, téléphone"
          class="border bg-white border-[#ec4400] rounded-lg py-2 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-orange-200 w-full sm:w-2/5"
        />
        
        <input
          type="date"
          v-model="startDate"
          placeholder="Date Début"
          class="border bg-white border-[#ec4400] rounded-lg py-2 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-orange-200 w-1/2 sm:w-1/5"
        />
        <input
          type="date"
          v-model="endDate"
          placeholder="Date Fin"
          class="border bg-white border-[#ec4400] rounded-lg py-2 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-orange-200 w-1/2 sm:w-1/5"
        />

        <select
          v-model="selectedDepartment"
          class="border bg-white border-[#ec4400] rounded-lg py-2 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-orange-200 w-1/2 sm:w-1/5"
        >
          <option value="">Tous les départements</option>
          <option v-for="dept in departments" :key="dept.id" :value="dept.name">{{ dept.name }}</option>
        </select>

        <select
          v-model="selectedBadge"
          class="border bg-white border-[#ec4400] rounded-lg py-2 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-orange-200 w-1/2 sm:w-1/5"
        >
          <option value="">Tous les badges</option>
          <option v-for="badge in availableBadges" :key="badge.id" :value="badge.badge_number">{{ badge.badge_number }}</option>
        </select>

        <button
          v-if="startDate || endDate || searchQuery"
          @click="clearFilters"
          class="bg-gray-200 text-gray-700 px-3 py-2 rounded-lg text-sm hover:bg-gray-300 transition-colors duration-200 flex-shrink-0"
        >
          Effacer
        </button>
      </div>

      <button
        @click="downloadPdf"
        class="text-white px-4 py-2 rounded-2xl text-sm hover:bg-white transition-colors duration-200 flex items-center space-x-2 w-full sm:w-auto flex-grow sm:flex-grow-0"
      >
        <i class="fas fa fa-download text-lg text-[#ec4400]"></i>
      </button>
    </div>
    
    <div
      class="bg-white shadow-sm rounded-lg border border-[#ec4400] overflow-hidden"
    >
      <div class="overflow-x-auto">
        <table class="min-w-full text-sm text-left text-gray-700">
          <thead
            class="bg-gray-50 text-xs uppercase font-semibold text-gray-500"
          >
            <tr>
              <th class="px-3 py-2 text-xs">Agent Entrée</th>
              <th class="px-3 py-2 text-xs">Agent Sortie</th>
              <th class="px-3 py-2 text-xs">Type de piece</th>
              <th class="px-3 py-2 text-xs">Numéro de Pièce</th>
              <th class="px-3 py-2 text-xs">Nom</th>
              <th class="px-3 py-2 text-xs">Prénoms</th>
              <th class="px-3 py-2 text-xs">Badge</th>
              <th class="px-3 py-2 text-xs">Personne Visitée</th>
              <th class="px-3 py-2 text-xs">Département</th>
              <th class="px-3 py-2 text-xs">Entreprise</th>
              <th class="px-3 py-2 text-xs">Téléphone</th>
              <th class="px-3 py-2 text-xs">Entrée</th>
              <th class="px-3 py-2 text-xs">Sortie</th>
              <th class="px-3 py-2 text-xs">Date</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="visiteur in paginatedvisitors"
              :key="visiteur.id"
              class="border-b border-gray-100 hover:bg-gray-50"
            >
              <td class="px-3 py-2">{{ visiteur.agent_entrance_name || "—" }}</td>
              <td class="px-3 py-2">{{ visiteur.agent_departure_name || "—" }}</td>
              <td class="px-3 py-2">{{ visiteur.id_card_type || "—" }}</td>
              <td class="px-3 py-2">{{ visiteur.id_card || "—" }}</td>
              <td class="px-3 py-2">{{ visiteur.sirname || "—" }}</td>
              <td class="px-3 py-2">{{ visiteur.first_name || "—" }}</td>
              <td class="px-3 py-2">{{ visiteur.badge_number || "—" }}</td>
              <td class="px-3 py-2">{{ visiteur.visited_person || "—" }}</td>
              <td class="px-3 py-2">{{ visiteur.department || "—" }}</td>
              <td class="px-3 py-2">{{ visiteur.company || "—" }}</td>
              <td class="px-3 py-2">{{ visiteur.phone || "—" }}</td>
              <td class="px-3 py-2">{{ visiteur.entrance_time || "—" }}</td>
              <td class="px-3 py-2">{{ visiteur.exit_time || "—" }}</td>
              <td class="px-3 py-2">{{ visiteur.entrance_date || "—" }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="flex justify-between items-center p-4 border-t border-gray-200"
      >
        <button
          class="px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          :disabled="currentPage === 1"
          @click="prevPage"
        >
          <img
            src="@/assets/flecheap.png"
            alt="Flèche page précédente"
            class="h-5 w-auto object-contain"
          />
        </button>
        <span class="text-sm text-gray-600">
          {{ currentPage }} / {{ totalPages }}
        </span>
        <button
          class="px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          :disabled="currentPage === totalPages || totalPages === 0"
          @click="nextPage"
        >
          <img
            src="@/assets/flecheav.png"
            alt="Flèche page suivante"
            class="h-5 w-auto object-contain"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, watch } from 'vue';
import html2pdf from 'html2pdf.js';
import apiFetch, { companyApi } from '@/apiClient';

const API_URL = process.env.VUE_APP_API_URL;

export default {
  name: 'VisiteurDashboard',
  setup() {
    // Déclarations avec ref pour les variables réactives
    const visitors = ref([]);
    const searchQuery = ref('');
    const currentPage = ref(1);
    const itemsPerPage = ref(15);
    const sortColumn = ref('entrance_date');
    const sortDirection = ref('DESC');
    const totalItemsCount = ref(0);
    const startDate = ref('');
    const endDate = ref('');
    const kpiStats = ref(null);
    const errorMessage = ref('');
    const companyId = ref(null);
    const departments = ref([]);
    const availableBadges = ref([]);
    const selectedDepartment = ref('');
    const selectedBadge = ref('');
    
    // NOUVEAU: Stocker le mapping ID -> Username
    const usersMap = ref({}); 

    // --- FONCTION DE RÉCUPÉRATION DES AGENTS (UTILISATEURS) ---
    const fetchUsersMap = async () => {
        try {
            const usersList = await apiFetch('/auth/users');
            const map = {};
            usersList.forEach(user => {
                if (user.id && user.username) {
                    map[user.id] = user.username;
                }
            });
            usersMap.value = map;
        } catch (err) {
            console.error('Erreur fetch Users Map:', err);
        }
    };
    
    // --- FONCTION DE RÉCUPÉRATION DES visitors (Non modifiée dans la logique de fetch) ---
    const fetchvisitors = async () => {
      // ... (La logique de fetchvisitors reste identique)
      try {
        errorMessage.value = '';
        const params = new URLSearchParams();
        params.append('page', currentPage.value);
        params.append('limit', itemsPerPage.value);
        params.append('sortColumn', sortColumn.value);
        params.append('sortDirection', sortDirection.value);

        const isDefaultSort = sortColumn.value === 'entrance_date' && sortDirection.value === 'DESC';
        const hasOtherFilters = searchQuery.value || startDate.value || endDate.value;
        
        if (isDefaultSort && !hasOtherFilters) {
          params.append('todayOnly', 'true');
        } else {
          if (searchQuery.value) params.append('search', searchQuery.value);
          if (startDate.value) params.append('startDate', startDate.value);
          if (endDate.value) params.append('endDate', endDate.value);
        }

        if (selectedDepartment.value) params.append('department', selectedDepartment.value);
        if (selectedBadge.value) params.append('badge', selectedBadge.value);

        const url = `${API_URL}/visitors?${params.toString()}`;

        const response = await fetch(url, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.error || `Erreur réseau: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        
        visitors.value = result.data || [];
        totalItemsCount.value = result.totalCount || 0;

      } catch (err) {
        console.error('Erreur fetch visitors:', err);
        visitors.value = [];
        totalItemsCount.value = 0;
        errorMessage.value = `Erreur lors du chargement des visitors: ${err.message}`;
      }
    };

    const fetchCompanyScopedLists = async () => {
      try {
        const mine = await companyApi.getMine();
        companyId.value = mine.id;
        departments.value = await companyApi.getDepartments(companyId.value);
        availableBadges.value = await companyApi.getAvailableBadges(companyId.value);
      } catch (err) {
        console.error('Erreur chargement référentiels company:', err);
      }
    };
    
    // --- FONCTION DE RÉCUPÉRATION DES KPI (Non modifiée) ---
    const fetchKpiStats = async () => {
        // ... (La logique de fetchKpiStats reste identique)
        try {
            errorMessage.value = '';
            const url = `${API_URL}/visitors/dashboard-stats`;

            const response = await fetch(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.error || `Erreur réseau: ${response.status} ${response.statusText}`);
            }

            const result = await response.json();
            kpiStats.value = result;
        } catch (err) {
            console.error('Erreur fetch KPI:', err);
            kpiStats.value = null;
            errorMessage.value = `Erreur lors du chargement des KPI: ${err.message}`;
        }
    };

    /* * ----------------------------------------------------
     * PROPRIÉTÉS CALCULÉES (COMPUTED)
     * ----------------------------------------------------
     */
    // NOUVEAU: Transforme les IDs en Noms
    const transformedVisitors = computed(() => {
        // Si visitors est vide ou usersMap n'est pas prêt, retourne les données brutes
        if (!visitors.value.length) {
             return [];
        }

        // Mappe les IDs aux noms
        return visitors.value.map(visiteur => {
            const entranceUser = usersMap.value[visiteur.user_entrance] || visiteur.user_entrance || "—";
            const departureUser = usersMap.value[visiteur.user_departure] || visiteur.user_departure || "—";
            
            return {
                ...visiteur,
                // Nouveaux champs utilisés dans le template
                agent_entrance_name: entranceUser,
                agent_departure_name: departureUser,
            };
        });
    });
    
    const paginatedvisitors = computed(() => transformedVisitors.value); // Utilise la version transformée
    const totalPages = computed(() => Math.ceil(totalItemsCount.value / itemsPerPage.value));

    /* * ----------------------------------------------------
     * INITIALISATION ET WATCHERS
     * ----------------------------------------------------
     */
    onMounted(() => {
      fetchCompanyScopedLists();
      fetchUsersMap(); // 👈 Charge la carte des utilisateurs au montage
      fetchvisitors();
      fetchKpiStats();
    });

    watch([searchQuery, startDate, endDate, selectedDepartment, selectedBadge], () => {
      currentPage.value = 1;
      fetchvisitors();
    });
    
    // Re-calculer l'affichage (via 'computed') lorsque la carte utilisateur change
    watch(usersMap, () => {
      // Re-déclenche juste la re-calcul de transformedVisitors, pas besoin de refetch
    });

    watch(currentPage, () => {
      fetchvisitors();
    });

    /* * ----------------------------------------------------
     * FONCTIONS DE NAVIGATION / FILTRES / PDF
     * ----------------------------------------------------
     */
    const prevPage = () => {
      if (currentPage.value > 1) currentPage.value--;
    };

    const nextPage = () => {
      if (currentPage.value < totalPages.value) currentPage.value++;
    };

    const clearFilters = () => {
      startDate.value = '';
      endDate.value = '';
      searchQuery.value = '';
      
      sortColumn.value = 'entrance_date';
      sortDirection.value = 'DESC';
      selectedDepartment.value = '';
      selectedBadge.value = '';
      
      currentPage.value = 1;
      errorMessage.value = '';
      fetchvisitors();
    };

    const downloadPdf = async () => {
      // Pour le PDF, nous devons utiliser les données TRANSFORMÉES
      const params = new URLSearchParams();
      params.append('sortColumn', sortColumn.value);
      params.append('sortDirection', sortDirection.value);
      params.append('limit', '99999'); 
      params.append('page', '1');

      const isDefaultSort = sortColumn.value === 'entrance_date' && sortDirection.value === 'DESC';
      const hasOtherFilters = searchQuery.value || startDate.value || endDate.value;
      
      if (isDefaultSort && !hasOtherFilters) {
        params.append('todayOnly', 'true');
      } else {
        if (searchQuery.value) params.append('search', searchQuery.value);
        if (startDate.value) params.append('startDate', startDate.value);
        if (endDate.value) params.append('endDate', endDate.value);
      }

      if (selectedDepartment.value) params.append('department', selectedDepartment.value);
      if (selectedBadge.value) params.append('badge', selectedBadge.value);

      try {
        const url = `${API_URL}/visitors?${params.toString()}`;

        const response = await fetch(url, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.error || `Erreur réseau: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        // Transformation des données complètes pour le PDF
        const usersToPrint = result.data.map(u => ({
            ...u,
            agent_entrance_name: usersMap.value[u.user_entrance] || u.user_entrance || "—",
            agent_departure_name: usersMap.value[u.user_departure] || u.user_departure || "—",
        })) || [];

        if (usersToPrint.length === 0) {
          alert('Aucun visiteur à télécharger selon les filtres actuels.');
          return;
        }
        
        // Construction du HTML du tableau (avec les noms d'agents)
        let tableHtml = `
          <style>
            table { width: 100%; border-collapse: collapse; margin-top: 15px; }
            th, td { border: 1px solid #ccc; padding: 6px; text-align: left; font-size: 8px; }
            th { background-color: #f2f2f2; color: #ec4400; font-weight: bold; }
            h2 { color: #ec4400; text-align: center; margin-bottom: 10px; font-size: 16px; }
            .report-info { font-size: 10px; margin-bottom: 5px; }
            .kpi-section { margin-bottom: 20px; }
            .kpi-item { font-size: 10px; margin: 5px 0; }
          </style>
          <h2>Rapport des visiteurs</h2>
          <div class="report-info">Total d'enregistrements: ${usersToPrint.length}</div>
          <div class="report-info">Filtre Recherche: ${searchQuery.value || 'N/A'}</div>
          <div class="report-info">Filtre Date: ${
            isDefaultSort && !hasOtherFilters ? 'Aujourd\'hui' : `Du ${startDate.value || 'Début'} au ${endDate.value || 'Fin'}`
          }</div>
          <table>
            <thead>
              <tr>
                <th>Agent Entrée</th>
                <th>Agent Sortie</th>
                <th>Numéro pièce</th>
                <th>Nom</th>
                <th>Prénoms</th>
                <th>Entreprise</th>
                <th>Téléphone</th>
                <th>Date</th>
                <th>Heure Entrée</th>
                <th>Heure Sortie</th>
              </tr>
            </thead>
            <tbody>
        `;

        usersToPrint.forEach(u => {
          tableHtml += `
            <tr>
              <td>${u.agent_entrance_name || '—'}</td>
              <td>${u.agent_departure_name || '—'}</td>
              <td>${u.id_card || '—'}</td>
              <td>${u.sirname || '—'}</td>
              <td>${u.first_name || '—'}</td>
              <td>${u.company || '—'}</td>
              <td>${u.phone || '—'}</td>
              <td>${u.entrance_date || '—'}</td>
              <td>${u.entrance_time || '—'}</td>
              <td>${u.exit_time || '—'}</td>
            </tr>
          `;
        });

        tableHtml += `
            </tbody>
          </table>
        `;

        const options = {
          margin: 10,
          filename: `rapport_visitors_${new Date().toISOString().slice(0, 10)}.pdf`,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' },
        };

        html2pdf().set(options).from(tableHtml).save();
      } catch (err) {
        console.error('Erreur lors de l\'export PDF:', err);
        alert(`Erreur lors de la génération du PDF: ${err.message}`);
      }
    };

    return {
      searchQuery,
      paginatedvisitors,
      currentPage,
      totalPages,
      prevPage,
      nextPage,
      kpiStats,
      startDate,
      endDate,
      clearFilters,
      downloadPdf,
      totalItemsCount,
      errorMessage,
      itemsPerPage,
      departments,
      availableBadges,
      selectedDepartment,
      selectedBadge,
    };
  },
};
</script>